<template>
  <div class="page_baoyang_add">
    <van-nav-bar
      title="保养记录"
      left-text="返回"
      left-arrow
      @click-left="back"
    />
    <van-form
      class="container"
      @submit="onSubmit"
      :show-error="false"
      :scroll-to-error="true"
    >
      <div class="content c1" :class="showType === 3 ? 'dis' : 'nodis'">
        <h3>1.任务信息</h3>

        <van-field
          required
          v-model="form.upkeepName"
          label="任务名称："
          placeholder="任务名称"
          :rules="[{ required: true, message: '请填写任务名称' }]"
        />
        <Select
          :searchMode="true"
          v-model="form.classificationCode"
          url="/emm/emmStockInfo/selectRecycleClassification"
          :params="{}"
          keys="classificationCode"
          showName="classificationName"
          :required="true"
          label="保养物资通用名："
          @change="emmConfirm"
        >
        </Select>
        <DaySelect
          label="保养日期："
          :required="true"
          v-model="form.completeTime"
          :shortTime="false"
        >
        </DaySelect>
        <van-field
          required
          v-model="form.operator"
          label="保养人员："
          placeholder="保养人员"
          :rules="[{ required: true, message: '请填写保养人员' }]"
        />
        <van-field
          v-model="form.upkeepItem"
          rows="2"
          autosize
          label="保养内容"
          type="textarea"
          maxlength="250"
          placeholder="请输入保养内容"
          show-word-limit
        />
      </div>
      <div class="content c2">
        <h3>2.保养物资列表</h3>
        <van-cell-group inset>
          <van-swipe-cell v-for="(row, index) in form.items" :key="index">
            <van-cell
              style="margin-top: 15px"
              :border="false"
              :title="row.alias"
              :value="row.upkeepQty + row.unit"
            />
            <template #right>
              <van-button
                style="height: 100%"
                native-type="button"
                square
                :type="
                  !row.resource || row.resource === '' ? 'warning' : 'info'
                "
                :disabled="!row.resource || row.resource === ''"
                text="保养说明"
                @click="delItems(index)"
              />
              <van-button
                style="height: 100%"
                v-if="showType !== 3"
                native-type="button"
                square
                type="danger"
                text="删除"
                @click="delItems(index)"
              />
            </template>
          </van-swipe-cell>
        </van-cell-group>
        <van-action-sheet
          v-model="itemsPicker"
          :actions="itemsList"
          @select="itemsComfirm"
          cancel-text="取消"
          title="物资列表"
        />
        <van-button
        style="margin-top:15px"
          v-if="showType !== 3"
          native-type="button"
          type="info"
          block
          plain
          icon="plus"
          @click="itemsPickerClick"
          >新增</van-button
        >
      </div>
      <div class="content c3">
        <h3>3.保养凭证</h3>
        <Uploader
          v-model="form.attachments"
          :disabled="showType === 3"
        ></Uploader>
      </div>
      <van-button
        v-if="showType !== 3"
        round
        block
        type="primary"
        native-type="submit"
        style="width: 80%; margin: 15px auto"
        >提 交</van-button
      >
    </van-form>

    <van-overlay :show="loading">
      <van-loading size="50px" />
    </van-overlay>
  </div>
</template>
<script>
export default {
  props: ["showType", "showData"],
  components: {},
  data() {
    return {
      form: {
        upkeepName: "",
        classificationName: "",
        classificationCode: "",
        completeTime: "",
        operator: "",
        upkeepItem: "",
        items: [],
        attachments: "",
      },
      loading: false,
      itemsPicker: false,
      itemsList: [{ name: "加载中", loading: true }],
    };
  },
  created() {
    if (this.showType > 1) {
      this.getData(this.showData.id);
    }else{
      this.setInfo()
    }
    this.getList();
    
  },
  methods: {
    back() {
      this.$emit("close");
    },
    setInfo(){
      this.form.completeTime = new Date()
      let userInfo = this.$util.get('userInfo')
      this.form.operator = userInfo.nickName
      console.log(userInfo)
      
    },
    getData(id) {
      this.$http.get("/emm/emmUpkeepInfo/get", { id }).then((res) => {
        this.form = res.data;
      });
    },
    getList() {
      this.$http
        .get("/emm/emmStockInfo/selectRecycleClassification", {})
        .then((res) => {
          this.emmList = res.data;
        });
    },
    emmConfirm(val) {
      console.log(val);
      this.form.items = [];
      this.form.classificationName = val.classificationName;
    },
    itemsPickerClick() {
      let code = this.form.classificationCode;
      //this.itemsPicker = true;
      if (code && code !== "") {
        this.loading = true;
        let that = this;
        this.$http
          .get(
            "/emm/emmStockInfo/getStockByClassification?classificationCode=" +
              code,
            {}
          )
          .then((res) => {
            let arr = [];
            let list = res.data;
            list.forEach((item) => {
              let indexs = that.form.items.findIndex(
                (i) =>
                  i.upkeepQty === item.upkeepQty &&
                  i.storageLevel === item.storageLevel
              );
              if (indexs >= 0) {
                item.disabled = true;
              }
              item.name = item.alias + "（" + item.upkeepQty + item.unit + "）";
              item.subname =
                (item.brandName ? item.brandName : "") +
                "/" +
                (item.modelName ? item.modelName : "");
              arr.push(item);
            });
            this.itemsList = arr;
            this.loading = false;
            this.itemsPicker = true;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        return this.$msg.top("danger", "请先选择保养物资通用名！");
      }
    },
    delItems(index) {
      this.form.items.splice(index, 1);
    },
    itemsComfirm(val) {
      console.log(val);
      this.form.items.push(val);
      this.itemsPicker = false;
    },
    onSubmit() {
      let f = JSON.parse(JSON.stringify(this.form));
      if (f.items.length < 1) {
        return this.$msg.info("保养物资列表不能为空");
      }
      let url = "";
      if (this.showType === 2) {
        url = "/emm/emmUpkeepInfo/updateUpkeep";
      } else {
        url = "/emm/emmUpkeepInfo/addUpkeep";
      }
      f.completeTime = this.$util.timeForhg(f.completeTime,true);
      this.$http.post(url, f).then((res) => {
        if (res.code === 0) {
          this.$msg.success("提交成功");
          this.back();
        } else {
          this.$msg.error("提交失败");
        }
      });
    },
  },
};
</script>
<style lang="scss">
.page_baoyang_add {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #f6f9f8;
  .container {
    width: 100vw;
    height: calc(100vh - 46px);
    overflow-x: hidden;
    overflow-y: auto;
    .content {
      background: #fff;
      margin: 10px 0;
      padding: 10px 16px;
      h3 {
        padding: 10px 0;
      }
      &.c2 {
        .van-cell {
          background-color: #eee;
          border-bottom: 1px solid #ccc;
          &:last-child {
            border: none;
          }
        }
      }
    }
  }
  .van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>